// src/components/background-canvas/index.js
import React, { Component } from 'react'
import throttle from 'lodash.throttle'
import './background-canvas.css'

class BackgroundCanvas extends Component {

  
  constructor(props) {
    super(props)
    this.state = {
      colourIndex: this.props.colourIndex || 0
    }
  }
  
  shouldComponentUpdate(nextProps) {
    const { 
      active: nextActive,
      colours: nextColours,
      colourIndex: nextCurrentIndex
    } = nextProps
    const {
      active: prevActive,
      colourIndex: prevCurrentIndex,
      colours: prevColours
    } = this.props 

    if (nextActive) {
      const isIndexChange = nextCurrentIndex !== prevCurrentIndex
      const isColourChange = nextColours !== prevColours
      if (isIndexChange || isColourChange) return true
    } 

    if (nextActive !== prevActive) return true

    return false
  }
  
  componentWillReceiveProps(props) {
    const colourDidUpdate = props.active && props.colourIndex !== this.props.colourIndex
    colourDidUpdate && this.updateColour(props.colourIndex)
  }
  
  updateColour = throttle((colourIndex) => {
    this.setState({ colourIndex: colourIndex })
  }, 200)

  render() {
    const { colours } = this.props 
    const { colourIndex } = this.state 
    const backgroundStyle = {
      backgroundColor: (colours && colours.get(colourIndex)) ? colours.get(colourIndex).colour : '#f3f1ed'
    }

    return (
      <div style={backgroundStyle} className="background-canvas">
        {this.props.children}
      </div>
    )

    /*
    const { colours, currentIndex } = this.props
    const backgroundStyle = {
      backgroundColor: colours ? colours.get(0).colour : '#eadddd'
    }
    
    return (
      <div style={backgroundStyle} className="background-canvas">
        <div className="background-canvas__list">
          {colours && this.renderCollectionBackgrounds(colours, currentIndex)}
        </div>
        {this.props.children}
      </div>
    )
    */
  }
}

export default BackgroundCanvas



// WEBPACK FOOTER //
// ./src/components/background-canvas/background-canvas.js